export default __webpack_public_path__ + "static/media/icon-aircraft.bb515b2a.svg";